<template>
    <div class="flex-1 p-10 text-2xl font-bold">Dashboard</div>
</template>

<script>
export default {
    name: "DashboardPage",
};
</script>
